<script>
    import Sede from "./Sede.svelte";

    export let sedes;
</script>

<style>
    ul {
        --anchoMinimo: calc(var(--ancho) / 4 - var(--padding-global));
        margin: 0;
        padding: 0;
        list-style: none;
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(var(--anchoMinimo), 1fr));
        grid-gap: var(--padding-global);
    }

    li {
        display: flex;
        flex-direction: column;
        height: 100%;
    }
</style>

<div class="parrillaDeSedes">
    <div class="inner">
        <ul>
            {#each sedes as sede (sede.id)}
                <li>
                    <Sede {sede} on:eliminar-sede />
                </li>
            {/each}
        </ul>
    </div>
</div>